import styled from "styled-components";
import { color } from "../../../../shared/styles";
import { TextareaAutosize } from "@mui/material";

export const StyledTextArea = styled(TextareaAutosize)`
    border-radius: 8px;
    border: 1px solid #ccd5df;
    height: 100%;
    padding: 8px 16px;
    resize: none;

    font-family: Noto Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;

    &::placeholder {
        color: ${color.emphasis.NEUTRAL_N30};
    }

    &:focus {
        border: 1px solid ${color.primary.BLUE_B100};
        box-shadow: none;
        outline: none;
    }
`;
